import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-dentnetpro',
  templateUrl: './add-dentnetpro.component.html',
  styleUrls: ['./add-dentnetpro.component.scss']
})
export class AddDentnetproComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
